import React, { FC, LegacyRef, ReactNode, forwardRef } from 'react';
import { FloatingLabelFormField as LegacyFloatingLabelFormField } from './component.legacy';
import { FloatingLabelFormField as NewFloatingLabelFormField } from './component';

export interface FloatingLabelFormFieldProps {
  children?: ReactNode;
  caption?: string;
  className?: string;
  as?: string;
  dataValue?: string | number | readonly string[] | readonly number[] | null;
  disabled?: boolean;
  errorMessage?: string | boolean | null;
  hasError?: boolean;
  ignorePattern?: boolean;
  isFloatOutside?: boolean;
  isValid?: () => boolean;
  labelClassName?: string;
  name?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: ((...args: any[]) => void) | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur?: ((...args: any[]) => void) | null;
  populatedOverride?: boolean;
  required?: boolean;
  type?: string;
  role?: string;
  runValidation?: boolean;
  searchField?: boolean;
  tooltip?: string | null;
  tooltipPosition?: string;
  placeholder?: string;
  valueOverride?: boolean;
  renderAsLegacy?: boolean;
  maxLength?: number;
  maxlength?: number;
  ref?: LegacyRef<HTMLDivElement>;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  hintText?: string;
  hintLink?: ReactNode;
  validationType?: string;
  'aria-describedby'?: string;
  hideControlLabelAria?: boolean;
}

export const FloatingLabelFormField = forwardRef<HTMLDivElement, FloatingLabelFormFieldProps>(
  ({ renderAsLegacy = true, maxlength, ...restProps }, ref) => {
    // Map legacy 'maxlength' to standard 'maxLength' for the new component
    const propsWithMappedMaxlength = {
      ...restProps,
      maxLength: restProps.maxLength ?? maxlength, // Prefer standard, fallback to legacy
    };

    const Component = (
      renderAsLegacy ? LegacyFloatingLabelFormField : NewFloatingLabelFormField
    ) as React.ComponentType<FloatingLabelFormFieldProps & { ref?: LegacyRef<HTMLDivElement> }>;

    return <Component {...propsWithMappedMaxlength} ref={ref} renderAsLegacy={renderAsLegacy} />;
  }
);

FloatingLabelFormField.displayName = 'FloatingLabelFormField';
